import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;
`;

export const CheckBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border: 2px solid #d3d9f7;
  border-radius: 6px;
  margin-left: 10px; 
  cursor: pointer;
`;

export const CheckBoxCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  opacity: ${props => (props.checked ? 1 : 0)};
  transition: opacity 0.3s;
  background: #7e77eb;
`;

export const Texts = styled.p`
  white-space: wrap;
  font-size: 12px;
  color: #a7a7be;
  margin-bottom: 0;
  user-select: none;

  .normal-text {
    font-size: 12px;
    color: #a7a7be;
    display: inline-block;
  }

  .link-text {
    display: inline-block;
    font-size: 12px;
    color: #6d65ec;
    cursor: normal;
    margin: 0 4px;
  }
`;
